import classNames from "classnames";

export default function HeadingText({
  children,
  classes = "",
  variant = "h2",
}) {
  const variantClasses = {
    //h1: "text-5xl font-bold",
    h2: "text-3xl font-medium mb-5 font-serif text-gray-800",
    h3: "text-2xl font-medium mb-5 font-sans text-primary",
    h4: "text-xl font-medium mb-4 font-sans text-gray-800",
    // h5: "text-xl font-medium",
    // h5: "text-xl font-medium",
    // h6: "text-lg font-normal",
  };

  const headingClasses = variantClasses[variant] || variantClasses.h2;

  const HeadingTag = variant;

  return (
    <HeadingTag className={classNames(headingClasses, classes)}>
      {children}
    </HeadingTag>
  );
}
